import { IconButton, makeStyles, Menu } from '@material-ui/core';
import { NotificationDotsIcon } from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { path } from 'app/utils/path';
import { navigateWithSearchState } from 'app/utils/search-state';
import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import styles from './NotificationDotsMenu.module.scss';

interface Props {
  withoutOpenNotification?: boolean;
  ReadTheNotification: any;
  // setIsAllRead?: any;
  handleMenuClose?: any;
}
const isEn = getFromLocalStorage('LNG') == 'en' ? true : false;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    border: '1px solid var(--borderColor)',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    top: '100px !important',
  },
}));

const NotificationDotsMenu: FunctionComponent<Props> = ({
  withoutOpenNotification,
  ReadTheNotification,
  // setIsAllRead,
  handleMenuClose,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const showPopper = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };
  const classes = useStyles();
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div
      className={styles.NotificationDotsMenu}
      data-testid="NotificationDotsMenu"
    >
      <IconButton onClick={handleClick} className={styles.iconHolder}>
        <NotificationDotsIcon />
      </IconButton>
      <div className="popper">
        <Menu
          data-testid="NotificationDotsMenu-popper"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            className: `${classes.paper}`,
            elevation: 0,
            style: {
              overflow: 'visible',
              marginTop: 1.5,
              top: '50px',
              position: 'absolute',
            },
          }}
          transformOrigin={{
            horizontal: isEn ? 'right' : 'left',
            vertical: 'top',
          }}
          anchorOrigin={{
            horizontal: isEn ? 'right' : 'left',
            vertical: 'bottom',
          }}
        >
          <div className={styles.popper}>
            <ul>
              <li
                onClick={() => {
                  ReadTheNotification();
                  // setIsAllRead(true);
                }}
              >
                {_t('basic:mark_all_as_read')}
              </li>
              <li onClick={() => handleMenuClose()}>
                <Link
                  to={navigateWithSearchState(
                    path.settings.NOTIFICATIONS_SETTINGS,
                    { activeTabId: 'sidebar_settings' }
                  )}
                >
                  {_t('basic:notification_settings')}
                </Link>
              </li>
              {!withoutOpenNotification && (
                <li onClick={() => handleMenuClose()}>
                  <Link to={path.settings.NOTIFICATIONS}>
                    {_t('basic:open_notifications')}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </Menu>
      </div>
    </div>
  );
};

export default NotificationDotsMenu;
